import type { Company } from '../@types/Company';

/**
 * Get the display name for a company.
 * Returns the commercial name from branding settings if set, otherwise the legal name.
 * 
 * @param company - The company object
 * @returns The commercial name if set, otherwise the legal name
 */
export function getCompanyDisplayName(company: Company | undefined | null): string {
  if (!company) {
    return '';
  }
  
  const commercialName = company.brandingSettings?.commercialName;
  return commercialName && commercialName.trim() !== '' ? commercialName : company.name;
}

export function slugify(text: string): string {
  return text
    .normalize('NFD')
    .replaceAll(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replaceAll(/[^a-z0-9]+/g, '-')
    .replaceAll(/^-+|-+$/g, '');
}

const CONSENT_DOMAIN = 'https://prendre-un-rendez-vous.fr';

export function getConsentUrl(company: Company | null, ownerUuid: string): string {
  const companySlug = slugify(getCompanyDisplayName(company) || 'syndic');

  return `${CONSENT_DOMAIN}/${companySlug}/syndic/${ownerUuid}`;
}
